import { Routes } from 'constants/pages';
import * as React from 'react';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { emailAvailabilityStatus } from 'services/clients/user';

/**
 * On mount, checks if the provided email is already validated and
 * if so continues the sign in process
 * @param email the email to send the validation email to
 */
export const useCheckOnMount = (email: string | null) => {
  const navigate = useNavigate();
  const mutation = useMutation(emailAvailabilityStatus, {
    onSuccess: (response) => {
      switch (response) {
        case 'needs_validation':
          // do nothing, we should be here
          return;
        case 'available':
        case 'needs_account':
          // navigate to sign in
          navigate(`${Routes.SignUp}?email=${encodeURIComponent(email || '')}`);
          break;
        default:
          // go to sign in
          navigate(Routes.SignIn);
          break;
      }
    },
  });

  React.useEffect(() => {
    if (email) {
      mutation.mutate(email);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
